import { gql } from '@apollo/client';

export default gql`
  query PreviewImportHotelBooking($options: PreviewImportHotelBookingInput!) {
    previewImportHotelBooking(options: $options) {
      bookingCode
      pnr
      originalPrice
      totalPrice
      priceBeforeMargin
      margin
      product
      marginPercentage
      region {
        countryForVat
      }
      rooms {
        code
        from
        to
        duration
        originalPrice
        totalPrice
        priceBeforeMargin
        margin
        marginPercentage
        currencyShort
        roomTypeCode
        rateBasisId
        roomName
        errata {
          subject
          description
        }
        invoiced
        status
        adults
        children
        passengersDetails {
          code
          firstName
          lastName
          leading
        }
        cancellations {
          startDate
          endDate
          penalty
          refundPercentage
          refundType
        }
      }
      hotel {
        id
        region
        regionName
        name
        slug
        rating
        location {
          longitude
          latitude
        }
        address
        overview
        country
      }
    }
  }
`;
